<!--
  Edit View
-->
<div
  class="btn-group"
  data-test-selector="write-state"
  *ngIf="canUpdateOpinion"
>
  <!-- Up vote -->
  <button
    class="btn btn-default button-border btn-xs"
    data-test-selector="up-vote-button"
    [ngClass]="{
      'btn-primary green-text': crossOpinion === 'approve',
      'btn-warning text-light': crossOpinion === 'review'
    }"
    (click)="toggleUpVoteClick()"
  >
    <i class="far fa-thumbs-up"></i>
    <span>{{ approveCount }}</span>
  </button>

  <!-- Down vote -->
  <button
    class="btn btn-default button-border btn-xs"
    data-test-selector="down-vote-button"
    [ngClass]="{
      'btn-danger': crossOpinion === 'dispute',
      'btn-warning text-light': crossOpinion === 'review'
    }"
    (click)="toggleDownVoteClick()"
  >
    <i class="far fa-thumbs-down"></i>
    <span>{{ disputeCount }}</span>
  </button>
</div>

<!--
  Read-only view
-->
<div
  class="btn-group read-only"
  data-test-selector="ready-only-state"
  *ngIf="!canUpdateOpinion"
>
  <div>
    <!-- Up vote -->
    <i
      class="fa fa-thumbs-up"
      data-test-selector="read-only-up-vote"
      [ngClass]="{
        'green-text': crossOpinion === 'approve',
        'text-warning': crossOpinion === 'review',
        'gray-color': crossOpinion !== 'approve' && crossOpinion !== 'review'
      }"
    >
      <span [ngClass]="{ 'gray-color': crossOpinion === 'no_opinion' }">{{
        approveCount
      }}</span>
    </i>
    <!-- Down vote -->
    <i
      class="fa fa-thumbs-down"
      data-test-selector="read-only-down-vote"
      [ngClass]="{
        'text-danger': crossOpinion === 'dispute',
        'text-warning': crossOpinion === 'review',
        'gray-color': crossOpinion !== 'dispute' && crossOpinion !== 'review'
      }"
    >
      <span [ngClass]="{ 'gray-color': crossOpinion === 'no_opinion' }">{{
        disputeCount
      }}</span>
    </i>
  </div>
</div>
